// @ts-nocheck
import {FC} from 'react'
import {ColumnInstance} from 'react-table'
import {Track} from '../../../../_models/_tracks-models'

type Props = {
  column: ColumnInstance<Track>
}

const CustomHeaderColumn: FC<Props> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th {...column.getHeaderProps()}>{column.render('Header')}</th>
    ) : (
      column.render('Header')
    )}
  </>
)

export {CustomHeaderColumn}
